import { render, staticRenderFns } from "./EditBasicDetailsAction.vue?vue&type=template&id=3205abbf&scoped=true&"
import script from "./EditBasicDetailsAction.vue?vue&type=script&lang=js&"
export * from "./EditBasicDetailsAction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3205abbf",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
